import React, { Component } from 'react'

import { downloadPdfData } from '../../common/utils'
import { getJSON } from '../../common/services/api'
import { gaEvent } from '../../common/services/analytics'
import { ButtonOLD } from '@lmc/ui-kit'
import Glyph from '../../LEGACY/Glyph'

interface PdfExportProps {
  getDocDefinition?: (result: any) => Promise<any>
  hideIcon?: boolean
  pdfTitle: string
  style?: React.CSSProperties
  text?: string
  dataUrl?: string
  url?: string
  disabled?: boolean
}

interface PdfExportState {
  isLoading: boolean
}

// PDF Fonts
const pdfFonts = {
  Roboto: {
    normal:
      'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/fonts/Roboto/Roboto-Regular.ttf',
    bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/fonts/Roboto/Roboto-Medium.ttf',
    italics:
      'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/fonts/Roboto/Roboto-Italic.ttf',
    bolditalics:
      'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.7/fonts/Roboto/Roboto-MediumItalic.ttf',
  },
}

class PdfExport extends Component<PdfExportProps, PdfExportState> {
  state: PdfExportState = {
    isLoading: false,
  }

  createPdf = async (result: any): Promise<void> => {
    try {
      const { getDocDefinition, pdfTitle } = this.props
      const pdfMake = (await import('pdfmake/build/pdfmake')).default
      const docDefinition = await getDocDefinition?.(result)
      // @ts-ignore
      pdfMake.createPdf(docDefinition, null, pdfFonts).download(pdfTitle)
      this.setState({ isLoading: false })
    } catch (err) {
      console.log('Pre-download function error: ', err)
    }
  }

  fetchPdf = (): void => {
    const { pdfTitle, url } = this.props
    getJSON({ url: url as string, responseType: 'arrayBuffer' }).then((res) => {
      downloadPdfData(res, pdfTitle)
      this.setState({ isLoading: false })
    })
  }

  fetchData = (url: string): void => {
    getJSON({ url }).then(async (res) => {
      await this.createPdf(res.result)
      this.setState({ isLoading: false })
    })
  }

  getPdf = (): void => {
    this.setState({ isLoading: true })
    if (this.props.url) {
      this.fetchPdf()
    } else if (this.props.dataUrl) {
      this.fetchData(this.props.dataUrl)
    } else {
      this.createPdf(undefined)
    }
    this.triggerGAEvent()
  }

  triggerGAEvent = (): void => {
    const { pathname } = window.location
    let action = ''
    let label = ''

    if (pathname.match(/\/residents\//)) {
      if (pathname.match(/\/charts\//)) {
        action = 'Resident charts'
        // @ts-ignore
        label = pathname.split('/').splice(-1).pop()
      } else if (pathname.match(/\/daily-report$/)) {
        action = 'Resident daily report'
      } else if (pathname.match(/\/profile$/)) {
        action = 'Resident daily report'
      } else if (pathname.match(/\/care-plans$/)) {
        action = 'Hospital passport'
      } else if (pathname.match(/\/care-plans\/$/)) {
        action = 'Resident care plan adl'
        // @ts-ignore
        label = pathname.split('/').splice(-1).pop() // ADL id
      } else if (pathname.match(/\/risk-assessments\/$/)) {
        action = 'Resident risk assessment'
      }
    }

    gaEvent({
      category: 'PDF Download',
      action,
      label,
    })
  }

  render(): React.ReactNode {
    const { style, text, disabled } = this.props
    const { isLoading } = this.state
    const displayText = text || BUTTON_TEXT

    return (
      <ButtonOLD
        dataTestId="pdf-export"
        onClick={this.getPdf}
        style={style}
        type="secondary"
        isLoading={isLoading}
        disabled={disabled}
        // @ts-ignore
        icon={<Glyph name="file-pdf" />}
      >
        {displayText}
      </ButtonOLD>
    )
  }
}

const BUTTON_TEXT = 'Download PDF'

export default PdfExport
